import { useVariableSizeInfiniteLoader } from '@/app/_hooks/useVariableSizeInfiniteLoader'
import { fetchEventsByType } from '@/backend/apis/event/GetEventsByTypeAPI'
import { EventStatus, PaginatedEvents } from '@/backend/models/Event'
import { encodeCursor } from '@/libraries/cursor'
import dayjs from 'dayjs'

export function useGetEvents(opts: {
  initialData: PaginatedEvents['data']
  limit: number
  type: EventStatus
}) {
  return useVariableSizeInfiniteLoader({
    key: `events-${opts.type}`,
    size: opts.limit,
    initialItems: opts.initialData,
    getInitialCursor: (item) =>
      encodeCursor({
        lastStartDate: dayjs.utc(item.endDate).toDate(),
      }),
    nextPageFetcher: async (size, cursor) => {
      const response = await fetchEventsByType({
        limit: size,
        cursor,
        type: opts.type,
      })

      if (response.status === 'error')
        throw new Error(response.error || 'unknown error')

      return response.data
    },
  })
}
